import { useState } from "react";
import { useNavigate } from "react-router-dom";

import {
  Alert,
  Box,
  Button,
  Checkbox,
  CircularProgress,
  FormControlLabel,
  IconButton,
  InputAdornment,
  Paper,
  TextField,
  Typography,
} from "@mui/material";

import {
  Visibility,
  VisibilityOff,
  LockOutlined,
  LoginOutlined,
} from "@mui/icons-material";

import logo from "../../assets/images/praneesh-infotech-logo.png";

function Login() {
  const navigate = useNavigate();

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const [showPassword, setShowPassword] = useState(false);

  const [rememberMe, setRememberMe] = useState(false);

  const [error, setError] = useState("");

  const [loading, setLoading] = useState(false);

  const handleLogin = (event) => {
    event.preventDefault();

    setError("");

    if (!username.trim()) {
      setError("Please enter your username.");
      return;
    }

    if (!password.trim()) {
      setError("Please enter your password.");
      return;
    }

    setLoading(true);

    // Temporary static login
    setTimeout(() => {
      if (
        username.trim() === "admin" &&
        password === "admin@123"
      ) {
        if (rememberMe) {
          localStorage.setItem(
            "crm_remember",
            "true"
          );
        }

        localStorage.setItem(
          "crm_logged_in",
          "true"
        );

        localStorage.setItem(
          "crm_user",
          JSON.stringify({
            name: "Admin",
            role: "Super Admin",
            username: "admin",
          })
        );

        navigate("/dashboard", {
          replace: true,
        });
      } else {
        setError(
          "Invalid username or password."
        );
      }

      setLoading(false);
    }, 700);
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",

        display: "flex",

        alignItems: "center",

        justifyContent: "center",

        position: "relative",

        overflow: "hidden",

        background:
          "linear-gradient(135deg, #F5FAFA 0%, #FFFFFF 50%, #EEF8F8 100%)",

        px: 2,
      }}
    >
      {/* =========================================
          BACKGROUND DECORATION
      ========================================== */}

      <Box
        sx={{
          position: "absolute",

          width: 450,

          height: 450,

          borderRadius: "50%",

          background:
            "rgba(0, 139, 139, 0.06)",

          top: -180,

          right: -150,
        }}
      />

      <Box
        sx={{
          position: "absolute",

          width: 350,

          height: 350,

          borderRadius: "50%",

          background:
            "rgba(0, 139, 139, 0.05)",

          bottom: -150,

          left: -120,
        }}
      />

      {/* =========================================
          LOGIN CARD
      ========================================== */}

      <Paper
        elevation={0}
        sx={{
          position: "relative",

          zIndex: 2,

          width: "100%",

          maxWidth: 450,

          borderRadius: 3,

          border: "1px solid #E4E7EC",

          backgroundColor: "#FFFFFF",

          boxShadow:
            "0 20px 50px rgba(16, 24, 40, 0.10)",

          overflow: "hidden",
        }}
      >
        {/* =========================================
            TOP BRAND AREA
        ========================================== */}

        <Box
          sx={{
            px: {
              xs: 3,
              sm: 5,
            },

            pt: {
              xs: 4,
              sm: 5,
            },

            pb: 3,

            textAlign: "center",
          }}
        >
          <Box
            component="img"
            src={logo}
            alt="Praneesh Infotech"
            sx={{
              width: "100%",

              maxWidth: 320,

              height: "auto",

              maxHeight: 95,

              objectFit: "contain",
            }}
          />

          <Typography
            sx={{
              mt: 3,

              fontSize: {
                xs: 21,
                sm: 23,
              },

              fontWeight: 700,

              color: "#333333",
            }}
          >
            Welcome Back
          </Typography>

          <Typography
            sx={{
              mt: 0.7,

              fontSize: 13,

              color: "#667085",
            }}
          >
            Sign in to access your CRM dashboard
          </Typography>
        </Box>

        {/* =========================================
            FORM
        ========================================== */}

        <Box
          component="form"
          onSubmit={handleLogin}
          sx={{
            px: {
              xs: 3,
              sm: 5,
            },

            pb: {
              xs: 4,
              sm: 5,
            },
          }}
        >
          {/* Error */}

          {error && (
            <Alert
              severity="error"
              sx={{
                mb: 2.5,

                borderRadius: 1.5,

                fontSize: 13,
              }}
            >
              {error}
            </Alert>
          )}

          {/* Username */}

          <Typography
            sx={{
              fontSize: 13,

              fontWeight: 600,

              color: "#344054",

              mb: 0.8,
            }}
          >
            Username
          </Typography>

          <TextField
            fullWidth
            placeholder="Enter username"
            value={username}
            onChange={(event) =>
              setUsername(event.target.value)
            }
            autoComplete="username"
            disabled={loading}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <LockOutlined
                    sx={{
                      fontSize: 20,

                      color: "#98A2B3",
                    }}
                  />
                </InputAdornment>
              ),
            }}
            sx={{
              mb: 2.2,

              "& .MuiOutlinedInput-root": {
                minHeight: 46,

                borderRadius: 1.5,

                "&.Mui-focused fieldset": {
                  borderColor: "#008B8B",
                },
              },
            }}
          />

          {/* Password */}

          <Typography
            sx={{
              fontSize: 13,

              fontWeight: 600,

              color: "#344054",

              mb: 0.8,
            }}
          >
            Password
          </Typography>

          <TextField
            fullWidth
            type={
              showPassword
                ? "text"
                : "password"
            }
            placeholder="Enter password"
            value={password}
            onChange={(event) =>
              setPassword(event.target.value)
            }
            autoComplete="current-password"
            disabled={loading}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <LockOutlined
                    sx={{
                      fontSize: 20,

                      color: "#98A2B3",
                    }}
                  />
                </InputAdornment>
              ),

              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={() =>
                      setShowPassword(
                        (previous) =>
                          !previous
                      )
                    }
                    edge="end"
                    disabled={loading}
                  >
                    {showPassword ? (
                      <VisibilityOff />
                    ) : (
                      <Visibility />
                    )}
                  </IconButton>
                </InputAdornment>
              ),
            }}
            sx={{
              "& .MuiOutlinedInput-root": {
                minHeight: 46,

                borderRadius: 1.5,

                "&.Mui-focused fieldset": {
                  borderColor: "#008B8B",
                },
              },
            }}
          />

          {/* Remember Me */}

          <Box
            sx={{
              display: "flex",

              alignItems: "center",

              justifyContent: "space-between",

              mt: 1.2,

              mb: 2.5,
            }}
          >
            <FormControlLabel
              control={
                <Checkbox
                  checked={rememberMe}
                  onChange={(event) =>
                    setRememberMe(
                      event.target.checked
                    )
                  }
                  disabled={loading}
                  sx={{
                    color: "#98A2B3",

                    "&.Mui-checked": {
                      color: "#008B8B",
                    },
                  }}
                />
              }
              label={
                <Typography
                  sx={{
                    fontSize: 12,

                    color: "#667085",
                  }}
                >
                  Remember me
                </Typography>
              }
            />

            <Typography
              sx={{
                fontSize: 12,

                fontWeight: 600,

                color: "#008B8B",

                cursor: "pointer",

                "&:hover": {
                  textDecoration:
                    "underline",
                },
              }}
            >
              Forgot password?
            </Typography>
          </Box>

          {/* Login Button */}

          <Button
            type="submit"
            fullWidth
            variant="contained"
            disabled={loading}
            startIcon={
              loading ? (
                <CircularProgress
                  size={18}
                  sx={{
                    color: "#FFFFFF",
                  }}
                />
              ) : (
                <LoginOutlined />
              )
            }
            sx={{
              height: 46,

              borderRadius: 1.5,

              backgroundColor: "#008B8B",

              fontSize: 14,

              fontWeight: 700,

              boxShadow:
                "0 4px 10px rgba(0, 139, 139, 0.20)",

              "&:hover": {
                backgroundColor: "#006F6F",

                boxShadow:
                  "0 6px 14px rgba(0, 139, 139, 0.25)",
              },
            }}
          >
            {loading
              ? "Signing in..."
              : "Sign In"}
          </Button>

          {/* Demo Credentials */}

          <Box
            sx={{
              mt: 3,

              p: 1.5,

              borderRadius: 1.5,

              backgroundColor: "#F8FAFC",

              border:
                "1px solid #EAECF0",
            }}
          >
            <Typography
              sx={{
                fontSize: 11,

                fontWeight: 700,

                color: "#475467",

                mb: 0.6,
              }}
            >
              Demo Login
            </Typography>

            <Typography
              sx={{
                fontSize: 11,

                color: "#667085",
              }}
            >
              Username:{" "}
              <strong>admin</strong>
            </Typography>

            <Typography
              sx={{
                fontSize: 11,

                color: "#667085",
              }}
            >
              Password:{" "}
              <strong>admin@123</strong>
            </Typography>
          </Box>
        </Box>

        {/* =========================================
            FOOTER
        ========================================== */}

        <Box
          sx={{
            borderTop:
              "1px solid #EAECF0",

            px: 3,

            py: 2,

            textAlign: "center",

            backgroundColor: "#FAFAFA",
          }}
        >
          <Typography
            sx={{
              fontSize: 10,

              color: "#98A2B3",
            }}
          >
            © {new Date().getFullYear()}{" "}
            Praneesh Infotech. All rights
            reserved.
          </Typography>

          <Typography
            sx={{
              fontSize: 9,

              color: "#98A2B3",

              mt: 0.3,
            }}
          >
            Technology | Innovation | Growth
          </Typography>
        </Box>
      </Paper>
    </Box>
  );
}

export default Login;